<div id="main">

  <button id="close" mat-dialog-close>
    <fa-icon [icon]="faTimes"></fa-icon>
  </button>

  <div id="parametersCont">

    <h4 class="info-csv">{{'EXPORT_MEASURE_DATA'|translate}}</h4>

    <div class="job-task-export-info" *ngIf="displayFeatureExportAsync">
      <div class="wording">
        {{'JOB_TASK_DISCLAIMER_1'|translate}}<br/>
        {{'JOB_TASK_DISCLAIMER_2'|translate}}<br/>
        {{'JOB_TASK_DISCLAIMER_3'|translate}}<br/>
      </div>
    </div>

    <div class="selectionContPickMain">

      <div id="datePickersCont">
        <div class="selectionContPick">
          <div class="selectionHeader"> {{'START_DATE' | translate}}</div>
          <mat-form-field class="date-picker">
            <input matInput [(ngModel)]="start_datePicker" [matDatepicker]="pickerDateStart" [max]="now">
            <mat-datepicker-toggle matSuffix [for]="pickerDateStart"></mat-datepicker-toggle>
            <mat-datepicker #pickerDateStart></mat-datepicker>
          </mat-form-field>
          <ngb-timepicker [(ngModel)]="start_timePicker" [seconds]="true" [meridian]="false"></ngb-timepicker>
          <button mat-stroked-button class="btn btn-primary smallButton"
                  (click)="resetPicker('start', project.start_date)"
                  [disabled]="!project">
            Fill with start date
          </button>
        </div>
        <div class="selectionContPick end">
          <div class="selectionHeader"> {{'END_DATE' | translate}}</div>
          <mat-form-field class="date-picker">
            <input matInput [(ngModel)]="end_datePicker" [matDatepicker]="pickerDateEnd" [max]="now">
            <mat-datepicker-toggle matSuffix [for]="pickerDateEnd"></mat-datepicker-toggle>
            <mat-datepicker #pickerDateEnd></mat-datepicker>
          </mat-form-field>
          <ngb-timepicker [(ngModel)]="end_timePicker" [seconds]="true" [meridian]="false"></ngb-timepicker>

          <button mat-stroked-button class="btn btn-primary smallButton" (click)="resetPicker('end')">Fill
            with
            today's
            date
          </button>

        </div>
      </div>

      <div class="selectionCont">
        <div class="selectionHeader">{{'MEASURES_OFFSET'|translate}}</div>
        <div class="wording">{{'PLEASE_OFFSET'|translate}}</div>
        <mat-selection-list>
          <mat-list-option *ngFor="let type of offsets" [value]="type.id" class="large"
                           [selected]="type.selected" (click)="setSelected('offsets', type.id)">
            {{type.id}}
          </mat-list-option>
        </mat-selection-list>
      </div>

    </div>


    <div class="selectionContMain">
      <div class="selectionCont">

        <div class="selectionHeader">{{ 'MEASURES' | translate }}</div>
        <mat-slide-toggle (change)="toggleSelection('types')">{{typesSelected ? ('CSV_ALL_SELECTED'|translate) :
          ('CSV_ALL_DISABLED'|translate)}}
        </mat-slide-toggle>
        <div class="wording">{{'PLEASE_MAKE_SELECTION'|translate}}</div>
        <mat-selection-list>
          <mat-list-option *ngFor="let type of types" [value]="type.id" class="small"
                           [selected]="type.selected" (click)="setSelected('types', type.id)">
            {{type.id | translate}}
          </mat-list-option>
        </mat-selection-list>

      </div>


      <div class="selectionCont">
        <div class="selectionHeader">{{'MEASURES_ORIGIN'|translate}}</div>

        <div class="wording">{{'PLEASE_SMS'|translate}}</div>
        <mat-button-toggle-group placement="left" appearance="standard"
                                 [(value)]="showSms" (change)="setShowSms($event)">
          <mat-button-toggle [value]="0">{{'ALL' | translate}}</mat-button-toggle>
          <mat-button-toggle [value]="1">{{'SMS' | translate}}</mat-button-toggle>
          <mat-button-toggle [value]="2">{{'MEASURE' | translate}}</mat-button-toggle>
        </mat-button-toggle-group>
      </div>


      <div class="selectionCont">
        <div class="selectionHeader">{{ 'DATA_TYPE' | translate }}</div>
        <mat-slide-toggle
          (change)="toggleSelection('dataTypes')">{{dataTypesSelected ? ('CSV_ALL_SELECTED'|translate) :
          ('CSV_ALL_DISABLED'|translate)}}
        </mat-slide-toggle>
        <div class="wording">{{'PLEASE_MAKE_SELECTION'|translate}}</div>
        <mat-selection-list>


          <mat-list-option *ngFor="let dataType of dataTypes" [value]="dataType.id"
                           [selected]="dataType.selected" (click)="setSelected('dataTypes', dataType.id)">
            {{dataType.id}}
          </mat-list-option>


        </mat-selection-list>

      </div>

      <div class="selectionCont">
        <div class="selectionHeader">{{ 'DATA_UNITS' | translate }}</div>
        <mat-slide-toggle (change)="toggleSelection('units')">{{unitsSelected ? ('CSV_ALL_SELECTED'|translate) :
          ('CSV_ALL_DISABLED'|translate)}}
        </mat-slide-toggle>
        <div class="wording">{{'PLEASE_MAKE_SELECTION'|translate}}</div>
        <mat-selection-list>


          <mat-list-option *ngFor="let unit of units" [value]="unit.id"
                           [selected]="unit.selected" (click)="setSelected('units', unit.id)">
            {{unit.name | translate}}
          </mat-list-option>

        </mat-selection-list>
      </div>

    </div>

    <div class="selectionContLocations">
      <div class="locationInfo">
        <!--<div class="wording">Please select at least one placement</div>-->
        <div class="wording">
          <!--{{'CSV_WARNING1'|translate}}<br>-->
          {{'CSV_WARNING2'|translate}}<br/>
          <span class="bold"> {{'CSV_WARNING3'|translate}}</span>
        </div>
      </div>
    </div>

  </div>
  <mat-progress-bar mode="indeterminate" *ngIf="isLoading===true"></mat-progress-bar>


  <div id="sensorCont">

    <div class="selectionHeaderMain">
      <div class="selectionHeader sensorHeader">{{ 'SENSORS' | translate }}</div>
      <mat-slide-toggle
        (change)="toggleSelection('locations')">{{locationsSelected ? ('CSV_ALL_SELECTED'|translate) :
        ('CSV_ALL_DISABLED'|translate)}}
      </mat-slide-toggle>
    </div>

    <div [ngStyle]="{opacity: isLoading ? 0.5 : 1}">
      <div class="locationList" *ngIf="!hasError">
        <mat-selection-list>
          <mat-list-option *ngFor="let location of locations" [value]="location.id"
                           [selected]="location.selected" (click)="setSelected('locations', location.id)">
            {{location.name}} - {{location.id}}
          </mat-list-option>
        </mat-selection-list>
      </div>
      <div *ngIf="hasError" style="padding: 20px 10px">
        No location found for this project.
      </div>
    </div>

    <br clear="left"/>
    <div class="modal-footer">
      <button class="btn btn-neutral" mat-dialog-close>
        {{'CLOSE'|translate}}
      </button>
      <button *ngIf="displayFeatureExportAsync && authenticationService.userHasRoleOsmos()" type="button"
              class="btn btn-primary"
              [routerLink]="'/export-csv-tasks'"
              [queryParams]="{project_id: project.id}"
              [ngbTooltip]="'JOB_TASK_TOOLTIP' | translate" mat-dialog-close>
        <fa-icon [icon]="faTasks"></fa-icon>
        {{'JOB_TASK_LABEL_BTN'|translate}}
      </button>

      <button *ngIf="displayFeatureExportAsync  && authenticationService.userHasRoleOsmos()" type="button"
              class="btn btn-primary" (click)="getCsv('async')" [disabled]="hasError">
        {{'JOB_TASK_SCHEDULE_SELECTED_FILES'|translate}}
      </button>
      <button type="button" class="btn btn-primary" (click)="getCsv()" [disabled]="hasError">
        {{'DOWNLOAD_SELECTED_FILES'|translate}}
      </button>
    </div>

  </div>

</div>
